<template>
  <b-card class="rounded-0">
    <h4>
      {{ title }}
    </h4>
    <b-form
      class="mt-4"
      @submit.prevent="submit">
      <b-form-group
        id="acceptRequest"
        label-for="acceptRequest">
        <div slot="label">
          {{ $t('message.signUpContactPerson.label.acceptRequest') }}
          <span class="text-danger">*</span>
        </div>
        <b-form-radio-group
          v-model="contactPersonRequest.isAccepted"
          :options="requestOptions"
          :state="$v.contactPersonRequest.isAccepted.$error ? false : null"
          @change="$v.contactPersonRequest.isAccepted.$touch()">
        </b-form-radio-group>
      </b-form-group>
      <b-form-group
        v-if="contactPersonRequest.isAccepted === 'true'"
        id="hasAccount"
        label-for="hasAccount">
        <div slot="label">
          {{ $t('message.signUpContactPerson.label.hasAccount') }}
          <span class="text-danger">*</span>
        </div>
        <b-form-radio-group
          v-model="contactPersonRequest.hasAccount"
          :options="accountOptions"
          :state="$v.contactPersonRequest.hasAccount.$error ? false : null"
          @change="$v.contactPersonRequest.hasAccount.$touch()">
        </b-form-radio-group>
      </b-form-group>
      <b-form-group
        v-if="contactPersonRequest.hasAccount === 'true'"
        id="relation"
        label-for="relation">
        <div slot="label">
          {{ relationText }}
          <span class="text-danger">*</span>
        </div>
        <b-form-select
          class="rounded-0"
          v-model="relation"
          :options="relationTypes">
        </b-form-select>
      </b-form-group>
      <b-form-row
        class="mt-4">
        <b-col class="text-right">
          <b-btn variant="primary" type="submit">
            {{ $t('message.signUpContactPerson.btn.submit') }}
          </b-btn>
        </b-col>
      </b-form-row>
    </b-form>
  </b-card>
</template>
<script>
  import {required, requiredIf} from 'vuelidate/lib/validators'

  export default {
    name: 'SignUpContactPerson',
    beforeRouteEnter (to, from, next) {
      next(vm => {
        if (to.query.invitationId) {
          vm.$store.dispatch('fetchInvitationByUuid', to.query.invitationId)
            .catch(() => {
              next('/')
            })
        } else {
          next('/')
        }
      })
    },
    computed: {
      invitation () {
        return this.$store.getters.invitation
      },
      relationText () {
        return this.$t('message.signUpContactPerson.label.relation', {
          firstName: this.invitation.policyHolderFirstName,
          lastName: this.invitation.policyHolderLastName,
          salutation: this.invitation.policyHolderSalutation ? this.$t('enums.salutations.' + this.invitation.policyHolderSalutation) : undefined
        })
      },
      relationTypes () {
        return this.$store.getters.relationTypes.map((relationType) => {
          return {
            value: relationType,
            text: this.$t('enums.relationTypes.' + relationType)
          }
        })
      },
      title () {
        return this.$t('message.signUpContactPerson.title', {
          firstName: this.invitation.policyHolderFirstName,
          lastName: this.invitation.policyHolderLastName,
          salutation: this.invitation.policyHolderSalutation ? this.$t('enums.salutations.' + this.invitation.policyHolderSalutation) : undefined
        })
      }
    },
    data () {
      return {
        accountOptions: [
          {value: 'true', text: this.$t('message.signUpContactPerson.accountOptions.yes')},
          {value: 'false', text: this.$t('message.signUpContactPerson.accountOptions.no')}
        ],
        contactPersonRequest: {},
        relation: this.$store.getters.relationTypes[0],
        requestOptions: [
          {value: 'true', text: this.$t('message.signUpContactPerson.requestOptions.yes')},
          {value: 'false', text: this.$t('message.signUpContactPerson.requestOptions.no')}
        ]
      }
    },
    methods: {
      submit () {
        this.$v.$touch()
        if (!this.$v.$invalid) {
          if (this.contactPersonRequest.isAccepted === 'true' && this.contactPersonRequest.hasAccount === 'true') {
            this.invitation.relation = this.relation
            this.$store.commit('setInvitation', this.invitation)
            this.$router.replace('/signin')
          } else if (this.contactPersonRequest.isAccepted === 'true' && this.contactPersonRequest.hasAccount === 'false') {
            this.$router.replace('/signup')
          } else {
            this.$store.dispatch('deleteInvitation', this.invitation.uuid)
              .then(() => {
                this.$router.replace('/signUpContactPersonRejected')
              })
              .catch(() => {
                this.showErrorMsg({
                  message: this.$t('error.signUpContactPerson.delete')
                })
              })
          }
        }
      }
    },
    validations: {
      contactPersonRequest: {
        hasAccount: {
          required: requiredIf((vueInstance) => {
            return vueInstance.isAccepted === 'true'
          })
        },
        isAccepted: {
          required
        }
      },
      relation: {
        required: requiredIf((vueInstance) => {
          return vueInstance.isAccepted === 'true' && vueInstance.hasAccount === 'true'
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/auth/SignUpContactPerson.vue